import { render } from "./App.vue?vue&type=template&id=173614c0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=173614c0&lang=less"

import exportComponent from "/Users/fanglegefang/Desktop/Feiyi_sign_2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__